import {
  type Layout,
  Responsive as ResponsiveGridLayout,
  type ResponsiveProps,
} from 'react-grid-layout';
import { useMeasure } from 'react-use';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import Box, { type BoxProps } from '@mui/material/Box';

export type BentoGridLayout = Layout;

export interface BentoGridProps extends ResponsiveProps {
  mode?: 'display' | 'editing';
  containerProps?: BoxProps;
}

export function BentoGrid({
  mode = 'display',
  children,
  containerProps,
  ...gridProps
}: BentoGridProps) {
  const [containerRef, { width }] = useMeasure<HTMLDivElement>();

  return (
    <Box
      {...containerProps}
      ref={containerRef}
      sx={{
        '& .react-grid-item': {
          display: 'flex',

          '&.react-draggable': {
            cursor: 'grab',
          },

          '&.react-draggable-dragging': {
            cursor: 'grabbing',
          },

          '&.react-grid-placeholder': {
            backgroundColor: 'indigo.600',
            cursor: 'grabbing',
          },
        },
        ...containerProps?.sx,
      }}
    >
      <ResponsiveGridLayout
        isDraggable={mode === 'editing'}
        isResizable={mode === 'editing'}
        rowHeight={48}
        cols={{ lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 }}
        containerPadding={[0, 0]}
        margin={[16, 16]}
        {...gridProps}
        width={width}
      >
        {children}
      </ResponsiveGridLayout>
    </Box>
  );
}
